import { render, staticRenderFns } from "./BackModal.vue?vue&type=template&id=03018f32&scoped=true"
import script from "./BackModal.vue?vue&type=script&lang=js"
export * from "./BackModal.vue?vue&type=script&lang=js"
import style0 from "./BackModal.vue?vue&type=style&index=0&id=03018f32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03018f32",
  null
  
)

export default component.exports